<template>
  <el-form-item :label="i18nt('designer.setting.draggable')">
    <el-switch v-model="optionModel.draggable"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n";

  export default {
    name: "tree-draggable-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// tree-draggable-editor.vue?de0e7cda